import { IPalette } from '@fluentui/react';

export const getStyles = (palette: IPalette) => {
  return {
    container: {
         flexDirection: 'row' as const,
         padding: 20,
         justifyContent: 'space-between' as const,
         alignItems: 'center' as const,
       },
       header: {
         flexDirection: 'row' as const,
       },
       transactionType: {
         fontSize: 16,
         paddingLeft: 10,
         color: palette.themePrimary,
         paddingHorizontal: 10,
       },
  };
};
